export const notificationsTypes = {
    getNotificationCount: '[NOTIFICATION] Get count',
    getNotificationInfo: '[NOTIFICATION] Get info',
    updateNotification: '[NOTIFICATION] update',
    deleteNotification: '[NOTIFICATION] delete',

}